//@ts-nocheck
import React, { forwardRef} from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { GrCalendar } from "react-icons/gr";
import { registerLocale } from "react-datepicker";
import { es, pt, enUS } from "date-fns/locale";
import { getAllMonths, rangeYears } from "../../utils/Common";
import { SelectShell } from "@/components/ui/select-shell";
import { FIELD_SKIN } from "@/components/ui/form-field";
import { cn } from "@/lib/utils";

const CustomDatePicker = ({
  selectedDate,
  onChangeDate,
  placeholder,
  startDate,
  endDate,
  name,
  disabled,
  isClearable,
  maxRangeDays = 90,
}) => {
  const langStorage = localStorage.getItem("language");
  const lang = langStorage ? langStorage : "enUS";

  const locales = {
    es: es,
    pt: pt,
    en: enUS,
  };

  const selectedLocale = locales[lang] || enUS;
  registerLocale(lang, selectedLocale);

  const preventTextInput = (event) => {
    event.preventDefault();
  };

  const handleStartDateChange = (date) => {
    onChangeDate(date);
    if (endDate && date && endDate.getTime() < date.getTime()) {
      onChangeDate(null, "end");
    }
  };

  const handleEndDateChange = (date) => {
    if (startDate) {
      onChangeDate(date);
    }
  };

  const isOutsideRange = (date) => {
    if (startDate) {
      const maxEndDate = new Date(startDate);
      maxEndDate.setDate(maxEndDate.getDate() + maxRangeDays);
      return date.getTime() > maxEndDate.getTime();
    }
    return false;
  };

  const getYear = (date) => {
    return date.getFullYear();
  };

  const getMonth = (date) => {
    return date.getMonth();
  };

  const years = rangeYears(2015, getYear(new Date()) + 1, 1);
  const months = getAllMonths();

  // The calendar glyph goes inside the field, like every other control, instead
  // of in a separate bordered cell glued to its left.
  const CustomInput = forwardRef(({ value, onClick, placeholderValue, disabled }, ref) => (
    <SelectShell icon={<GrCalendar size={15} />}>
      <input
        ref={ref}
        type="text"
        value={value}
        onClick={onClick}
        placeholder={placeholderValue}
        disabled={disabled}
        readOnly
        className={cn(FIELD_SKIN, 'w-full cursor-pointer pl-10 pr-3')}
      />
    </SelectShell>
  ));

  return (
    <div className="mb-3 flex w-full">
      <div className="flex-1">
        <DatePicker
          selected={selectedDate}
          onChange={startDate ? handleEndDateChange : handleStartDateChange}
          dateFormat="dd-MM-yyyy"
          customInput={<CustomInput placeholderValue={placeholder} disabled={disabled} />}
          isClearable={isClearable}
          startDate={startDate}
          endDate={endDate}
          minDate={startDate}
          maxDate={isOutsideRange}
          showIcon={false} // Desactiva el icono predeterminado
          name={name}
          disabled={disabled}
          onKeyDown={preventTextInput}
          renderCustomHeader={({
            date,
            changeYear,
            changeMonth,
            decreaseMonth,
            increaseMonth,
            prevMonthButtonDisabled,
            nextMonthButtonDisabled,
          }) => (
            <div
              style={{
                margin: 10,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <button
                className="rounded-md px-2 text-muted-foreground hover:bg-accent disabled:opacity-40"
                onClick={decreaseMonth}
                disabled={prevMonthButtonDisabled}
                type="button"
                aria-label="<"
              >
                {"<"}
              </button>
              <select
                className={cn(FIELD_SKIN, "mx-1 h-8 px-2 text-xs")}
                value={getYear(date)}
                onChange={({ target: { value } }) => changeYear(value)}
              >
                {years.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>

              <select
                className={cn(FIELD_SKIN, "mx-1 h-8 px-2 text-xs")}
                value={months[getMonth(date)]}
                onChange={({ target: { value } }) =>
                  changeMonth(months.indexOf(value))
                }
              >
                {months.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>

              <button
                className="rounded-md px-2 text-muted-foreground hover:bg-accent disabled:opacity-40"
                onClick={increaseMonth}
                disabled={nextMonthButtonDisabled}
                type="button"
                aria-label=">"
              >
                {">"}
              </button>
            </div>
          )}
          locale={lang}
        ></DatePicker>
      </div>
    </div>
  );
};

export default CustomDatePicker;
